import { ColorPickerIcon } from '@/utils/helpers/icons.helper';
import React from 'react';

type ContentInlineFormattingToolbarProps = {
  className?: string;
  toolbarId?: string;
  colorButtonId?: string;
  colorInputId?: string;
};

export const renderToolbar = (
  questionId: string | number,
  editorType: string,
) => {
  return (
    <ContentInlineFormattingToolbar
      key={`toolbar-${editorType}-${questionId}`}
      toolbarId={`inline-formatting-toolbar-${editorType}-${questionId}`}
      colorButtonId={`custom-color-btn-${editorType}-${questionId}`}
      colorInputId={`custom-color-input-${editorType}-${questionId}`}
    />
  );
};

export const ContentInlineFormattingToolbar: React.FC<
  ContentInlineFormattingToolbarProps
> = ({
  className,
  toolbarId = 'inline-formatting-toolbar',
  colorButtonId = 'custom-color-btn',
  colorInputId = 'custom-color-input',
}) => {
  return (
    <>
      <div id={toolbarId} className={className}>
        <span className="ql-formats">
          <button className="ql-bold" />
          <button className="ql-italic" />
          <button className="ql-underline" />
          <button className="ql-link" />
        </span>
        <span className="ql-formats relative">
          <button id={colorButtonId} type="button" className="custom-color-btn">
            <ColorPickerIcon />
          </button>
        </span>
      </div>
      <input
        type="color"
        id={colorInputId}
        style={{
          opacity: 0,
          position: 'absolute',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
        }}
      />
    </>
  );
};
